import React from 'react';
import './oursContent.scss';
import { Sign } from '../../components/image-router';
import { useTranslation } from 'react-i18next';

const OursContent = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='containerOurs'>
                <div className='textOurs'>
                    <div className='textContent'>
                        <div className='titleContent'>
                            {t('ours.title')}
                        </div>
                        <div className='subContent'>
                            {t('ours.subtitle')}
                        </div>
                        <p>{t('ours.paragraph1')}</p>
                        <div>&nbsp;</div>
                        <p>{t('ours.paragraph2')}</p>
                        <div>&nbsp;</div>
                        <p>{t('ours.paragraph3')}</p>
                        <div>&nbsp;</div>
                        <p>{t('ours.paragraph4')}</p>
                        <div>&nbsp;</div>
                        <p>{t('ours.paragraph5')}</p>
                        <div>&nbsp;</div>
                        <p>{t('ours.paragraph6')}</p>
                    </div>
                    <div className='signImage'>
                        <img src={Sign} alt="Sign" className='imageAdjust' />
                    </div>
                </div>
                <div className='directionsOurs'>
                    <p>{t('ours.address')}</p>
                    <div>&nbsp;</div>
                    <p>{t('ours.phone')}</p>
                    <div>&nbsp;</div>
                    <p>{t('ours.email')}</p>
                </div>
            </div>
        </>

    );
}

export default OursContent;
